import {
  Input,
  Tabs,
  Select,
  Upload,
  message,
  Col,
  Row,
  Popconfirm,
  Typography,
  Button,
  Space,
  notification,
  Divider,
  Tag,
} from "antd";
import { FileOutlined, CloseCircleFilled, DownloadOutlined, UploadOutlined, CloudDownloadOutlined, DeleteColumnOutlined, DeleteFilled, DeleteTwoTone } from "@ant-design/icons";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../context";
import { languageCodeList } from "../../langmap";

const getmimeType = {
  trailers: "video/mp4",
  audios: "audio/mp4",
  thumbnails: "image/*",
  subtitles: "text/*",
  video: "video/mp4",
  posters: "image/*",
};

const UploadSubtitles = (props) => {
  const { token, apiUrl } = useContext(Context);
  const [language, setLanguage] = useState("en");
  const [content, setContent] = useState(props.updateContent[0]);

  // useEffect(() => {
  //   if (props.updateContent[2] === undefined) {
  //     return;
  //   }
  //   // console.log("content before declaration - ", props.updateContent[0], props.updateContent[2])
  //   if (props.updateContent[0].length === 0) {
  //     setContent({ subtitles: {} });
  //     return;
  //   }
  //   if (props.updateContent[0].length <= props.updateContent[2]) {
  //     setContent({ subtitles: {} });
  //     return;
  //   }
  //   // console.log("episode content - ", props.updateContent[0][props.updateContent[2]])
  //   setContent(props.updateContent[0][props.updateContent[2]])
  // }, [props.updateContent[0], props.updateContent[2]])

  const deleteSubtitle = (lang, url) => {
    fetch(
      `${apiUrl}/uploads/subtitles/${props.upload._id}?language=${lang}&url=${url}&type=${props.upload.type}`,
      {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      }
    )
      .then((result) => {
        console.log(result);
        message.success("Delete successful ");
        if (content.subtitles) {
          let temp = {}
          for (let i in content.subtitles) {
            if (i !== lang) {
              temp = { ...temp, [i]: content.subtitles[i] }
            }
          }
          setContent({ ...content, subtitles: temp });
        }
        if (content.subtitles === {}) {
          props.uploadFlag[1](() => false)
        }
      })
      .catch((err) => {
        console.error(`Error deleting content`);
      });
  };

  console.log('props for subtitles - ', props)

  const handleUploadChange = (info) => {
    console.log("subtitles url - ", (info))
    if (info.file.response && info.file.response.success === true) {
      message.success("Updated Transcripts");
      sessionStorage.setItem("subtitles_data", JSON.stringify({ "season": props.upload, "subtitles": info.file.response.url, "language": info.file.response.language }));
      if (props.updateContent && content) {
        setContent({ ...content, subtitles: { ...content.subtitles, [info.file.response.language]: info.file.response.url } })
        if (Object.key(content.subtitles).length > 0) {
          props.updateFlag[1](() => true);
        }
      }
    }
  }

  return (
    <>
      <Space direction="inline">
        <Space direction="inline">
          <Select
            placeholder={"select language of subtitle to upload"}
            showSearch
            style={{ width: 300 }}
            value={language}
            disabled
            onChange={(value) => setLanguage(value)}
          >
            {languageCodeList.map((v) => (
              <Select.Option key={v["name"]} value={v["code"]} defaultValue={"en"}>
                {v["native"]} - {v["name"]}
              </Select.Option>
            ))}
          </Select>
          {language ? (
            <Upload
              showUploadList={true}
              listType="text"
              action={`${apiUrl}/uploads/subtitles/${props.upload._id}?language=${language}&type=${props.upload.type}`}
              accept=".srt,.vtt"
              headers={{
                authorization: `Bearer ${token}`,
              }}
              maxCount={1}
              defaultFileList={[]}
              progress={{
                strokeColor: {
                  "0%": "#108ee9",
                  "100%": "#87d068",
                },
                strokeWidth: 3,
                format: (percent) => `${parseFloat(percent.toFixed(2))}%`,
              }}
              onChange={handleUploadChange}
            >
              <Button style={{ fontSize: "15px", paddingBottom: "10px" }} icon={<UploadOutlined />} >Upload</Button>
            </Upload>
          ) : null}
        </Space>
        {content && "subtitles" in content && content.subtitles
          ? Object.entries(content.subtitles).map(([k, v]) => (
            <Row style={{
              marginTop: "8px",
            }}>
              {/* <Col>
                <Input
                  style={{ border: 1, marginTop: "-5px" }}
                  value={languageCodeList.filter((e) => e.code === k)[0]['name']}
                  readOnly
                  onChange={(value) => setLanguage(value)}
                ></Input>{" "}
              </Col> */}
              <Col>
                <a href={v} target="_blank">
                  <DownloadOutlined style={{ fontSize: "33px", margin: "5px", marginTop: "-7px", marginRight: "10px" }} />
                  {/* <FileOutlined style={{ fontSize: "20px" }}></FileOutlined> */}
                </a>
              </Col>
              <Col>
                <Popconfirm
                  placement="top"
                  title={`Do you want to delete ${k} Subtitle?`}
                  onConfirm={() => deleteSubtitle(k, v)}
                  okText={"Delete"}
                  cancelText="Cancel"
                  okType="danger"
                  icon={null}
                >
                  <DeleteTwoTone
                    twoToneColor={'red'}
                    style={{
                      fontSize: "28px",
                      marginTop: "-6px"
                    }}
                  />
                </Popconfirm>
              </Col>
            </Row>
          ))
          : null}
      </Space >
      <br></br>
      <Space style={{ marginTop: "10px" }}>
        {
          content && "subtitles" in content && content.subtitles &&  Object.keys(content.subtitles).length > 0? (
            <Tag color="green">Transcripts Exists</Tag>
          ) : (
            <Tag color="orange">Transcripts Unavailable</Tag>
          )
        }
      </Space>
    </>
  );
};

export default UploadSubtitles;
